import useImperativeNetworkRequestBase from '@root/core/src/hooks/use-imperative-network-request-base';
import useNetworkRequest from '@root/core/src/hooks/use-network-request';

export default function useImperativeNetworkRequest(requestConfigurationFunction) {
  return useImperativeNetworkRequestBase(requestConfigurationFunction, useNetworkRequest);
}
